<script lang="ts">
  // UI components
  import { Switch } from '$lib/components/ui/switch/index.js';
  import { Input } from '$lib/components/ui/input/index.js';
  import * as Table from '$lib/components/ui/table';
  import { Circle } from '@lucide/svelte';

  // RoastLog
  import TCName from '$lib/components/settings/TCName.svelte';
  import { selectedRoaster, selectedDeviceType } from '$lib/PersistedState.svelte';

  const labels = $derived(selectedRoaster.tcLabelNames);
  const hasHardcodedLabels = $derived(selectedDeviceType.hasHardcodedLabels);
  const sensorLabel = $derived(selectedDeviceType.sensorLabel);
</script>

{#if hasHardcodedLabels}
  <!-- Hardcoded-label devices (Modbus roasters): left-packed layout. -->
  <div class="mt-5 flex flex-wrap gap-6">
    <!-- TC1 - Always shown, always Bean -->
    <div class="flex flex-col gap-2">
      <div class="flex items-center gap-2 font-medium">
        {sensorLabel} 1
        <Circle fill={selectedRoaster.tcSettings.current[0].color} strokeWidth={0} size={16} />
      </div>
      <div class="text-sm">
        <Input value="Bean" readonly class="cursor-default" />
      </div>
    </div>

    {#if labels[1]}
      <div class="flex flex-col gap-2">
        <div class="flex items-center gap-2 font-medium">
          {sensorLabel} 2
          <Circle fill={selectedRoaster.tcSettings.current[1].color} strokeWidth={0} size={16} />
          <Switch bind:checked={selectedRoaster.tcSettings.current[1].active} />
        </div>
        <div class="text-sm">
          <Input value={labels[1] || ''} readonly class="cursor-default" />
        </div>
      </div>
    {/if}

    {#if labels[2]}
      <div class="flex flex-col gap-2">
        <div class="flex items-center gap-2 font-medium">
          {sensorLabel} 3
          <Circle fill={selectedRoaster.tcSettings.current[2].color} strokeWidth={0} size={16} />
          <Switch bind:checked={selectedRoaster.tcSettings.current[2].active} />
        </div>
        <div class="text-sm">
          <Input value={labels[2] || ''} readonly class="cursor-default" />
        </div>
      </div>
    {/if}

    {#if labels[3]}
      <div class="flex flex-col gap-2">
        <div class="flex items-center gap-2 font-medium">
          {sensorLabel} 4
          <Circle fill={selectedRoaster.tcSettings.current[3].color} strokeWidth={0} size={16} />
          <Switch bind:checked={selectedRoaster.tcSettings.current[3].active} />
        </div>
        <div class="text-sm">
          <Input value={labels[3] || ''} readonly class="cursor-default" />
        </div>
      </div>
    {/if}
  </div>
{:else}
  <!--
    Editable-label devices (Phidgets thermocouple, RTD, Simulator). Uses the
    same table geometry as TCSettings (leading w-24 column + 4 equal columns)
    so the labels/toggles line up with the offsets below.
  -->
  <Table.Root class="mt-5 w-full">
    <Table.Body>
      <Table.Row class="border-0 hover:bg-transparent">
        <Table.Cell class="w-24"></Table.Cell>
        <Table.Cell>
          <div class="flex items-center gap-2 font-medium">
            {sensorLabel} 1
            <Circle fill={selectedRoaster.tcSettings.current[0].color} strokeWidth={0} size={16} />
          </div>
          <div class="mt-2 text-sm">
            <Input value="Bean" readonly class="cursor-default" />
          </div>
        </Table.Cell>
        <Table.Cell>
          <div class="flex items-center gap-2 font-medium">
            {sensorLabel} 2
            <Circle fill={selectedRoaster.tcSettings.current[1].color} strokeWidth={0} size={16} />
            <Switch bind:checked={selectedRoaster.tcSettings.current[1].active} />
          </div>
          <div class="mt-2 text-sm">
            <TCName
              bind:name={selectedRoaster.tcSettings.current[1].name}
              bind:enabled={selectedRoaster.tcSettings.current[1].active}
            />
          </div>
        </Table.Cell>
        <Table.Cell>
          <div class="flex items-center gap-2 font-medium">
            {sensorLabel} 3
            <Circle fill={selectedRoaster.tcSettings.current[2].color} strokeWidth={0} size={16} />
            <Switch bind:checked={selectedRoaster.tcSettings.current[2].active} />
          </div>
          <div class="mt-2 text-sm">
            <TCName
              bind:name={selectedRoaster.tcSettings.current[2].name}
              bind:enabled={selectedRoaster.tcSettings.current[2].active}
            />
          </div>
        </Table.Cell>
        <Table.Cell>
          <div class="flex items-center gap-2 font-medium">
            {sensorLabel} 4
            <Circle fill={selectedRoaster.tcSettings.current[3].color} strokeWidth={0} size={16} />
            <Switch bind:checked={selectedRoaster.tcSettings.current[3].active} />
          </div>
          <div class="mt-2 text-sm">
            <TCName
              bind:name={selectedRoaster.tcSettings.current[3].name}
              bind:enabled={selectedRoaster.tcSettings.current[3].active}
            />
          </div>
        </Table.Cell>
      </Table.Row>
    </Table.Body>
  </Table.Root>
{/if}
